export default __webpack_public_path__ + "ffc2984ef37c41bba22196e195eae92a.png";